<template>
  <div>
    <q-card flat bordered>
      <q-card-section class="q-pa-sm bg-primary text-white">
        <div class="text-subtitle1 text-bold">
          <q-icon
            name="history"
            style="font-size: 25px; padding-right: 0.1rem"
          />
          {{ label }}
        </div>
      </q-card-section>
      <q-separator />
      <q-card-section v-if="!loadingData">
        <q-scroll-area style="height: 300px">
          <p
            v-for="event in events.filter(
              (event) => event.eventType === eventType
            )"
            :key="event.id"
          >
            {{ event.eventDate | localTime }} {{ event.description }}
          </p>
        </q-scroll-area>
      </q-card-section>
      <q-card-section v-else>
        <div class="q-py-xs">
          <q-skeleton type="rect" animation="fade" />
        </div>
        <div class="q-py-xs">
          <q-skeleton type="rect" animation="fade" />
        </div>
        <div class="q-py-xs">
          <q-skeleton type="rect" animation="fade" />
        </div>
      </q-card-section>
    </q-card>
  </div>
</template>
<script>
export default {
  name: 'AppQuoteHistoryCard',
  props: {
    loadingData: {
      type: Boolean,
      default: false
    },
    events: {
      type: Array,
      default: function () {
        return [];
      }
    },
    eventType: {
      type: String,
      default: 'GENERAL'
    },
    label: String
  }
};
</script>
